import { Component, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { LocalStorageService } from '@shared/service/local-storage/local-storage.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-products-container',
    templateUrl: './products-container.component.html',
    styleUrls: ['./products-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
})
export class ProductsContainerComponent implements OnDestroy {
    private localStorageService = inject(LocalStorageService);

    ngOnDestroy(): void {
        this.localStorageService.removeItem('slug');
        this.localStorageService.removeItem('active_index');
    }
}
